import { ReactElement, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle, Typography,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { IMessageContext, IStatusColor } from "../../types";
import { getPalette } from "../../configuration/configuration";


interface IProps {
  messageContext: IMessageContext | null;
}

const DialogMessage = ({ messageContext }: IProps): ReactElement => {
  const [ open, setOpen ] = useState<boolean>(false);

  useEffect(() => {
    setOpen(messageContext !== null);
  }, [ messageContext ]);

  const onAccept = () => {
    setOpen(false);
    messageContext?.callback();
  };

  const onCancel = () => {
    setOpen(false);
  };

  const statusColor = getPalette().statusColor[messageContext?.color as keyof IStatusColor ?? "blueGray"];

  return (
    <Dialog onClose={onCancel} aria-labelledby="customized-dialog-title" open={open} maxWidth="md">
      <DialogTitle id="customized-dialog-title" style={{ ...statusColor }}>
        {messageContext?.title}
      </DialogTitle>

      <DialogContent dividers={true}>
        <Typography className="p-4">{messageContext?.message}</Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onAccept} variant="contained" color="primary" startIcon={<CheckIcon />}>
          Accept
        </Button>
        <Button onClick={onCancel} variant="contained" color="secondary" startIcon={<CloseIcon />}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogMessage;
